module.exports = __webpack_public_path__ + "static/media/check-out.8d89c312.svg";